import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getImageUrl } from '../../../../utils/imageUrl';
import './InitiateRefundModal.css';

interface InitiateRefundModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  refundAmount: number;
  isLoading?: boolean;
}

const InitiateRefundModal: React.FC<InitiateRefundModalProps> = ({
  show,
  handleClose,
  handleConfirm,
  refundAmount,
  isLoading = false
}) => {
  const formatPrice = (price: number) => {
    return `₹${price.toLocaleString('en-IN')}`;
  };

  const handleModalClose = () => {
    if (!isLoading) {
      handleClose();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={handleModalClose}
      id="initiateRefundModal" 
      className="initiate-refund-modal fade zoomIn" 
      dialogClassName="modal-dialog-centered"
      centered
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
      enforceFocus={false}
    >
      <Modal.Body className="initiate-refund-modal-body">
        <div className="initiate-refund-content">
          {/* Illustration Image */}
          <div className="initiate-refund-image-container">
            <img 
              src={getImageUrl('admin/static-assets/shop-services/initiate-refund.webp')} 
              alt="Initiate Refund" 
              className="initiate-refund-image"
            />
          </div>
          
          {/* Heading */}
          <h4 className="initiate-refund-title">
            Initiate Refund?
          </h4>
          
          {/* Message */}
          <p className="initiate-refund-message">
            Are you sure you want to initiate refund?<br />
            Refund Amount: <strong>{formatPrice(refundAmount)}</strong>
          </p>
          
          {/* Buttons */}
          <div className="initiate-refund-button-container">
            <Button 
              type="button" 
              variant="outline-secondary" 
              className="initiate-refund-button initiate-refund-cancel-button" 
              onClick={handleModalClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button 
              type="button" 
              variant="primary" 
              className="initiate-refund-button initiate-refund-confirm-button" 
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Confirm'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InitiateRefundModal;
